export const REQUEST_PRODUCT_SEARCH =
  "monitoringService.REQUEST_PRODUCT_SEARCH";
export const RECEIVE_PRODUCT_SEARCH =
  "monitoringService.RECEIVE_PRODUCT_SEARCH";
export const ADD_PRODUCT = "monitoringService.ADD_PRODUCT";
export const REMOVE_PRODUCT = "monitoringService.REMOVE_PRODUCT";
export const SET_ALERT_PREFERENCES = "monitoringService.SET_ALERT_PREFERENCES";
export const REQUEST_ORDER_PRODUCT = "monitoringService.REQUEST_ORDER_PRODUCT";
export const RECEIVE_ORDER_PRODUCT = "monitoringService.RECEIVE_ORDER_PRODUCT";
